import { Globe } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { sandboxBrowserWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  sandboxBrowserWeb,
  {
    SandboxBrowserTab: () => import('./SandboxBrowserTab'),
    SandboxBrowserTabPreview: () => import('./SandboxBrowserTabPreview'),
  },
  {
    icons: { Globe },
  },
);
